'use client';

import './styles/@theme';
import { useWalletUm } from '@/hooks/use-wallet-um';
import { getText } from '@/utils/text/text';
import { formatNumberDefault } from '@/utils/numbers/format-number';
import { SvgLoader } from '@/app/elements/svg/loader';
import { useNotIdle } from '@/hooks/use-not-idle';
import { type RootState, useStore } from '@/store/store';
import { useEffect } from 'react';

const DOCUMENT_EVENTS: (keyof HTMLElementEventMap)[] = ['click', 'keydown', 'scroll', 'touchstart'];

export const Balance: React.FC = () => {
    const { balance, getWalletBalance, triggerDeposit } = useWalletUm();
    const showBalance = useStore((state: RootState) => state.userContext.accountSettings.showBalance);
    const initSessionCompleted = useStore((state: RootState) => state.userContext.session.initCompleted);

    useNotIdle(getWalletBalance, {
        events: DOCUMENT_EVENTS
    });

    useEffect(() => {
        if (initSessionCompleted) {
            getWalletBalance();
        }
    }, [initSessionCompleted]);

    const displayBalance = balance
        ? showBalance
            ? formatNumberDefault(balance.playableBalance)
            : '* * * * * *'
        : getText({ text: 'components.balance.loading' });

    const handleDeposit = () => {
        if (!initSessionCompleted) {
            console.log('Session not initialized yet. Deposit action aborted.');
            return;
        }
        triggerDeposit();
    };

    return (
        <div className="balance-container">
            <div className="funds">
                <p className="value">{displayBalance}</p>
                <p className="text">{getText({ text: 'components.balance.addFunds' })}</p>
            </div>
            <button
                onClick={handleDeposit}
                disabled={!initSessionCompleted}
                className={`btn add-funds${!initSessionCompleted ? ' disabled' : ''}`}>
                <SvgLoader iconName="plus" className="add-funds-icon" />
            </button>
        </div>
    );
};
